import { SizeProp } from "@fortawesome/fontawesome-svg-core";

type Props = {
  color: string;
  size: SizeProp;
};

export function Logo({ color, size }: Props): JSX.Element {
  return (
    <div className="inline-block w-64 py-4 m-0">
      <img className="inline-block" src="/logo-big-systher.svg" alt="" />
    </div>
  );
}
